<mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
